var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5543_13594)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.7778 1.76562C51.7778 1.20465 51.3232 0.75 50.7622 0.75C45.9197 0.75 41.1959 1.68985 36.722 3.54257C33.8695 4.72442 31.2091 6.2415 28.7668 8.0724C28.7347 8.06923 28.7017 8.06764 28.6688 8.06764C28.6597 8.06764 28.6506 8.06764 28.6414 8.06804C22.4188 8.23228 16.5674 10.7463 12.1661 15.148L6.75516 20.559C6.35844 20.9557 6.35844 21.5988 6.75516 21.9956L11.2556 26.4956L14.3624 29.6024C11.5246 32.7342 9.66278 36.7078 9.08872 40.9008L8.86734 42.5167C8.8241 42.8313 8.93082 43.1479 9.15537 43.3724C9.34738 43.5645 9.60605 43.67 9.87344 43.67C9.91907 43.67 9.96509 43.6668 10.0111 43.6605L11.627 43.4395C15.82 42.8654 19.7936 41.0036 22.9254 38.1658L26.0322 41.2722L30.5322 45.7726C30.7306 45.971 30.9909 46.0702 31.2507 46.0702C31.5106 46.0702 31.7704 45.971 31.9688 45.7726L37.3798 40.3621C41.7811 35.9604 44.2955 30.1094 44.4598 23.8868C44.461 23.8443 44.4586 23.8027 44.4546 23.7618C46.2859 21.3195 47.8034 18.6587 48.9848 15.8062C50.8384 11.3319 51.7778 6.60808 51.7778 1.76562ZM13.6023 16.5842C17.003 13.1838 21.348 11.0129 26.0453 10.3258C25.6291 10.7059 25.2197 11.0955 24.819 11.4958L11.9737 24.341L8.90979 21.2771L13.6023 16.5842ZM11.3517 41.4269L11.0612 41.4666L11.1009 41.1766C11.6151 37.4203 13.2726 33.8581 15.7998 31.0402L21.488 36.728C18.6697 39.2552 15.1075 40.9127 11.3517 41.4269ZM35.9432 38.9255L31.2507 43.6184L28.1864 40.5541L30.9052 37.8353C31.3015 37.439 31.3015 36.7959 30.9052 36.3992C30.5084 36.0024 29.8653 36.0024 29.4686 36.3992L26.7502 39.1175L23.6617 36.0294L13.4099 25.7776L26.2555 12.9323C32.5579 6.6295 40.8599 3.0534 49.7315 2.79592C49.4744 11.6679 45.8983 19.9699 39.5955 26.2723L35.5366 30.3312C35.1398 30.7279 35.1398 31.371 35.5366 31.7678C35.9333 32.1641 36.576 32.1641 36.9727 31.7678L41.0316 27.7088C41.4323 27.3081 41.8219 26.8987 42.2016 26.4826C41.5149 31.1798 39.344 35.5248 35.9432 38.9255Z",
    fill: "url(#paint0_linear_5543_13594)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1665 33.123C32.8983 33.123 32.6373 33.2306 32.4477 33.4206C32.2584 33.6094 32.1509 33.8705 32.1509 34.1387C32.1509 34.4057 32.2584 34.6679 32.4477 34.8567C32.6373 35.0456 32.8983 35.1543 33.1665 35.1543C33.4335 35.1543 33.6946 35.0456 33.8846 34.8567C34.0734 34.6679 34.1821 34.4057 34.1821 34.1387C34.1821 33.8705 34.0734 33.6094 33.8846 33.4206C33.6946 33.2306 33.4327 33.123 33.1665 33.123Z",
    fill: "url(#paint1_linear_5543_13594)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0722 21.4556C30.1133 20.4963 28.8378 19.9683 27.4814 19.9683C26.1254 19.9683 24.8499 20.4963 23.891 21.4556C22.9317 22.4145 22.4033 23.69 22.4033 25.0464C22.4033 26.4024 22.9317 27.6779 23.891 28.6368C24.8499 29.5961 26.1254 30.1245 27.4814 30.1245C28.8378 30.1245 30.1133 29.5961 31.0722 28.6368C32.0315 27.6779 32.5595 26.4024 32.5595 25.0464C32.5595 23.69 32.0315 22.4145 31.0722 21.4556ZM29.636 27.2006C29.0604 27.7763 28.2955 28.0932 27.4814 28.0932C26.6677 28.0932 25.9024 27.7763 25.3272 27.2006C24.7515 26.6254 24.4345 25.8601 24.4345 25.0464C24.4345 24.2323 24.7515 23.4674 25.3272 22.8917C25.9024 22.3161 26.6677 21.9995 27.4814 21.9995C28.2955 21.9995 29.0604 22.3161 29.636 22.8917C30.2113 23.4674 30.5283 24.2323 30.5283 25.0464C30.5283 25.8601 30.2113 26.6254 29.636 27.2006Z",
    fill: "url(#paint2_linear_5543_13594)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6908 19.915C39.0472 19.915 40.3227 19.3866 41.2816 18.4277C42.2409 17.4684 42.7689 16.1933 42.7689 14.8369C42.7689 13.4805 42.2409 12.205 41.2816 11.2461C40.3227 10.2868 39.0472 9.75879 37.6908 9.75879C36.3344 9.75879 35.0593 10.2868 34.1 11.2461C33.1411 12.205 32.6127 13.4805 32.6127 14.8369C32.6127 16.1933 33.1411 17.4684 34.1 18.4277C35.0593 19.3866 36.3344 19.915 37.6908 19.915ZM35.5366 12.6823C36.1118 12.1066 36.8771 11.79 37.6908 11.79C38.5049 11.79 39.2698 12.1066 39.8454 12.6823C40.4211 13.2579 40.7377 14.0228 40.7377 14.8369C40.7377 15.6506 40.4211 16.4159 39.8454 16.9911C39.2698 17.5668 38.5049 17.8838 37.6908 17.8838C36.8771 17.8838 36.1118 17.5668 35.5366 16.9911C34.9609 16.4159 34.6439 15.6506 34.6439 14.8369C34.6439 14.0228 34.9609 13.2579 35.5366 12.6823Z",
    fill: "url(#paint3_linear_5543_13594)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2059 42.6621L16.2655 49.6021C15.8688 49.9988 15.8688 50.6419 16.2655 51.0387C16.4639 51.2366 16.7237 51.3358 16.9836 51.3358C17.2435 51.3358 17.5033 51.2366 17.7017 51.0387L24.642 44.0983C25.0388 43.702 25.0388 43.0589 24.642 42.6621C24.2457 42.2658 23.6026 42.2654 23.2059 42.6621Z",
    fill: "url(#paint4_linear_5543_13594)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.55982 34.6266L0.676502 39.51C0.279774 39.9063 0.279774 40.5494 0.676502 40.9461C0.874865 41.1445 1.13472 41.2437 1.39458 41.2437C1.65444 41.2437 1.91429 41.1445 2.11266 40.9461L6.99598 36.0632C7.3927 35.6665 7.3927 35.0234 6.99598 34.6266C6.59925 34.2299 5.95655 34.2299 5.55982 34.6266Z",
    fill: "url(#paint5_linear_5543_13594)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.24661 33.3921C9.51361 33.3921 9.77466 33.2834 9.96469 33.0945C10.1535 32.9057 10.2622 32.6439 10.2622 32.3765C10.2622 32.1095 10.1535 31.8472 9.96469 31.6584C9.77466 31.4695 9.51361 31.3608 9.24661 31.3608C8.97922 31.3608 8.71738 31.4695 8.52735 31.6584C8.3385 31.8472 8.2298 32.1095 8.2298 32.3765C8.2298 32.6439 8.3385 32.9057 8.52735 33.0945C8.71738 33.2834 8.97922 33.3921 9.24661 33.3921Z",
    fill: "url(#paint6_linear_5543_13594)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3801 46.404L8.76776 51.0163C8.37104 51.4131 8.37104 52.0558 8.76776 52.4525C8.96613 52.6509 9.22598 52.75 9.48584 52.75C9.7457 52.75 10.0056 52.6509 10.2039 52.4525L14.8163 47.8401C15.213 47.4438 15.213 46.8007 14.8163 46.404C14.4195 46.0073 13.7768 46.0073 13.3801 46.404Z",
    fill: "url(#paint7_linear_5543_13594)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5543_13594",
    x1: 29.1177,
    y1: 0.75,
    x2: 39.8378,
    y2: 58.7338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A175FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#563AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5543_13594",
    x1: 33.1665,
    y1: 33.123,
    x2: 33.647,
    y2: 35.7219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A175FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#563AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5543_13594",
    x1: 27.4814,
    y1: 19.9683,
    x2: 29.8838,
    y2: 32.9624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A175FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#563AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5543_13594",
    x1: 37.6908,
    y1: 9.75879,
    x2: 40.0932,
    y2: 22.7529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A175FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#563AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5543_13594",
    x1: 20.4538,
    y1: 42.3647,
    x2: 22.5757,
    y2: 53.8426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A175FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#563AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_5543_13594",
    x1: 3.83624,
    y1: 34.3291,
    x2: 5.47182,
    y2: 43.1758,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A175FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#563AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_5543_13594",
    x1: 9.24602,
    y1: 31.3608,
    x2: 9.72623,
    y2: 33.9598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A175FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#563AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_5543_13594",
    x1: 11.792,
    y1: 46.1064,
    x2: 13.3635,
    y2: 54.6064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A175FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#563AFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5543_13594"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    fill: "white",
    transform: "translate(0.0742188 0.75)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionIcon);
export default __webpack_public_path__ + "static/media/ActionIcon.eb5aebb99c215988f23111ac6c079c43.svg";
export { ForwardRef as ReactComponent };